export default "__VITE_ASSET__CXVs_Y37__"